import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { DataGridFlexSales, useDataGridFlexSales } from '../DataGridFlexSales';

import {
  filterParametersSelector,
  reportFilterCountryCodeSelector,
  reportConciliationHeaderSelector,
  conciliationMethodSelector,
  masterDataSelector,
} from '../../state';
import { ConciliationHeader } from '../../types';
import handlerFactory, { ConciliationsDataGridContext } from './handlerFactory';

const DataGridConfig = () => {
  const { handler } = useDataGridFlexSales<ConciliationHeader, ConciliationsDataGridContext>();
  const { t } = useTranslation();
  const title = t('conciliationHeaders.title');
  const country = useSelector(reportFilterCountryCodeSelector);
  const conciliationMethod = useSelector(conciliationMethodSelector);
  const { data, loading } = useSelector(reportConciliationHeaderSelector);
  const appParameters = useSelector(filterParametersSelector);
  const masterData = useSelector(masterDataSelector);

  const federativeEntityByStore = useMemo(() => {
    const stores = masterData.data?.stores ?? [];
    return new Map(
      stores
        .filter(store => store.countryCode === country)
        .map(store => [
          store.storeAcronym,
          (country === 'BR' ? store.estadoSgl : store.stateProvince) || '-',
        ])
    );
  }, [masterData.data, country]);

  const gridContext = useMemo(
    () => ({
      t,
      country,
      storeExtraInfo: appParameters.data?.storeExtraInfo || [],
      conciliationMethod,
      federativeEntityByStore, // ← nuevo, y también en las dependencias de abajo
    }),
    [t, country, appParameters.data, conciliationMethod, federativeEntityByStore]
  );

  handler.setData(data);
  handler.setContext(gridContext);
  handler.setTitle(title);
  handler.setLoading(loading);
  return null;
};

const ConciliationHeaderDataGrid = () => (
  <DataGridFlexSales handlerFactory={handlerFactory}>
    <DataGridConfig />
  </DataGridFlexSales>
);

export default ConciliationHeaderDataGrid;
